module.exports = "/images/lines-5.jpg";